import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();
console.log("v0.20.4.2");

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(
        function(registrations) {
            var unregistered = false;
            for(let registration of registrations) { 
                registration.unregister();
                unregistered = true;
            }
            if(unregistered) {
                window.location.reload(true);
            }
        }
    );
}


// WEBPACK FOOTER //
// ./src/index.js